__turbopack_context__.v({
  "childRow": "FolderRow-module__TIUyrG__childRow",
});
